module.exports = __webpack_public_path__ + "resource/img/download-qr.cb211d4a.svg";